import store from "@/core/services/store";

let unwatchPresentation = null;

const updatePresentationClass = () => {
  if (typeof document === "undefined") return;

  document.documentElement.classList.toggle(
    "presentation-mode-active",
    store.getters["isPresentationMode"]
  );
};

const ensurePresentationWatcher = () => {
  if (unwatchPresentation || typeof document === "undefined") return;

  updatePresentationClass();

  unwatchPresentation = store.watch(
    (state) => state.presentation.presentationMode,
    updatePresentationClass
  );
};

ensurePresentationWatcher();

export default {
  bind(el) {
    ensurePresentationWatcher();
    el.classList.add("presentation-blur-target");
  },
  unbind(el) {
    el.classList.remove("presentation-blur-target");
  }
};
